/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ObjectValueModel.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ProductConfigurationFilterModel.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ProductConfigurationFilterItem.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/AttributeCustomValueModel.js" />
var noCoverObjectValueId = 10656;
var noCoverObjectValueV3Id = 11698;
var individualFormatObjectValueId = 11859;
var extentId = 202;
var extentV3Id = 218;

var AttributeModel = function (pageModelHndl, parentHndl) {
    var that = this;

    //baseData
    that.AttributeId = ko.observable();
    that.LocalizationKey = ko.observable();
    that.Description = ko.observable();
    that.ObjectValues = ko.observableArray([]);
    that._BeginnerObjectValues = ko.observableArray([]);
    that.DisplayColumns = ko.observable();
    that.IsExtension = ko.observable(parentHndl instanceof ExtensionModel);
    that.CustomValue = new AttributeCustomValueModel(pageModelHndl, that);
    that.CustomFormat = new AttributeCustomFormatModel(pageModelHndl, that);
    that.DefaultObjectValueId = ko.observable();

    //subData
    that.InnerLastSelected = ko.observable(-1);
    that.SelectedObjectValueId = ko.observable();
    that.SelectedObjectValue = ko.computed(function () {
        var attribute = that;
        var selectedObjectValueId = that.SelectedObjectValueId();
        return getObjectValue(attribute, selectedObjectValueId);
    }, this);

    that.IsCorrectionMode = ko.observable(false);
    that.ClickToggleCorrectionMode = function () {
        var isCorrectionMode = that.IsCorrectionMode();
        that.IsCorrectionMode(!isCorrectionMode);
    };

    that.PreviousAttributeHasValidValue = ko.computed(function () {
        var productModel = pageModelHndl.pProductModel;
        var attributes = productModel.Attributes();
        var index = attributes.indexOf(that);

        var previousIndex = index - 1;
        if (previousIndex < 0) {
            return true;
        }

        var previousAttribute = attributes[previousIndex];

        return previousAttribute.IsValid();
    }, that);

    that.IsValueStatic = ko.observable(false);
    that.IsValid = ko.computed(function () {
        var isValid = true;

        if (that.CustomValue.IsCustomValueOptionAvailable()) {
	        return that.CustomValue.IsValid();
        }
        
        if(that.CustomFormat.IsCustomFormatOptionAvailable() && that.CustomFormat.IsCustomFormatSelected()) {
            console.log("custom format selected");
            return that.CustomFormat.LengthIsValid() && that.CustomFormat.WidthIsValid();
        }

        for (var i = 0; i < that.ObjectValues().length; i++) {
            if (that.ObjectValues()[i].HasError()) {
                isValid = false;
            }
        }
        if (that.SelectedObjectValueId() === undefined) {
            isValid = false;
        }
        return isValid;
    }, that);

    that.IsVisible = ko.computed(function () {
        return !that.IsValueStatic();
    }, that);

    that.SetSelectedAttribute = function (Attribute, e) {
        // Remember Selected Attribute
        pageModelHndl.pProductModel.SelectedAttribute = Attribute;

        // check input visually
        var selectedValue = $(e.currentTarget).find('input:checked').val();

        // write value into model to keep everything in sync
        if (selectedValue) {
            that.SelectedObjectValueId(selectedValue);
        }
        return true;
    };

    that.GetSelectableValueIds = function () {
        var selectableIds = [];
        $.each(that.ObjectValues(), function (index, item) {
            if (item.IsEnabled()) {
                selectableIds.push(item.ObjectValueId());
            }
        });
        return selectableIds;
    };

    //subscriptions 
    that.SelectedObjectValueId.subscribe(function (newValueId) {        
        if (!pageModelHndl.IsProductModelPopulated()) {
            return;
        }

        if (newValueId) {
            // disable custom value selection
            that.CustomValue.IsCustomValueOptionSelected(false);
        }
        
        if (that.IsExtension()) {
            // Disables Extension configuration when no cover is selected
            parentHndl.IsDisabled(newValueId === noCoverObjectValueId || newValueId === noCoverObjectValueV3Id);
        }
        
        that.CustomFormat.IsCustomFormatSelected(newValueId === individualFormatObjectValueId);
        
        if (newValueId === undefined &&
            pageModelHndl.pProductContentModeModel.SelectedModeId() === 'MODE_0') {

            parentHndl.LastSelectedObjectValue(-1);
            pageModelHndl.pProductModel.UpdateProductModel();
        } else if (newValueId !== undefined && pageModelHndl.pProductModel.LastSelectedObjectValue() !== undefined
                && newValueId.toString() !== (pageModelHndl.pProductModel.LastSelectedObjectValue()).toString()) {
            if (!(pageModelHndl.pProductModel.IsProductModelRePopulating() && !(parentHndl.IsExtension()))) {
                pageModelHndl.pProductModel.LastSelectedObjectValue(-1);

                $.each(pageModelHndl.pProductModel.Extensions(), function (i, ext) {
                    ext.LastSelectedObjectValue(-1);
                });

                var productConfigurationFilterItem = new ProductConfigurationFilterItem(that);
                pageModelHndl.pProductModel.SelectedAttributeAndExtensionValues.push(productConfigurationFilterItem);

                parentHndl.LastSelectedObjectValue(newValueId);

                if (pageModelHndl.pProductContentModeModel.SelectedModeId() === "MODE_0") {
                    if (newValueId.toString() !== (that.InnerLastSelected()).toString()) {
                        pageModelHndl.pProductModel.UpdateProductModel();
                    }
                    that.InnerLastSelected(-1);
                }
                else {
                    that.InnerLastSelected(newValueId.toString());
                    pageModelHndl.pProductModel.UpdateProductModel();
                }

                that.IsCorrectionMode(false);
            }
        }
    });

    that.SelectedObjectValue.subscribe(function (objectValue) {
        var attributeId = that.AttributeId();

        // should be only material attribute for now
        var isLookupAttribute = attributeId === that.CustomValue.lookUpAttributeId;
        if (!isLookupAttribute) {
            return;
        }

        var customValueProperties = objectValue.CustomValueProperties;
        console.log("selected objectValue ", objectValue, " has ", customValueProperties.length, " custom values", customValueProperties);
        var hasCustomValues = customValueProperties.length > 0;
        // we could toggle the feature here, depending on selected material
        //that.IsCustomValueOptionAvailable(hasCustomValues);

        if (!hasCustomValues) {
            return;
        }

        that.CustomValue.applyCustomValues(customValueProperties);
    });

    //functions
    that.UpdateForBeginnerMode = function () {
        that._BeginnerObjectValues(that.ObjectValues.slice(0));
        if (pageModelHndl.IsProductModelPopulated()) {
            $.each(that.ObjectValues(), function (i, objVal) {
                if (objVal.HasError() || !objVal.IsEnabled()) {
                    that._BeginnerObjectValues.remove(objVal);
                }
            });
        }
    };

    that.SetBeginnerValueEnabled = function(option, item) {
        ko.applyBindingsToNode(option, { css: { nonExistantSelectedValue: item ? item.HasError() : false }, disable: item && that._BeginnerObjectValues.indexOf(item) === -1 }, item);
    };

    that.GetOptionText = function(item) {
        return item.LocalizationKey().replace(/<[^>]*>/g, '');
    };

    that.PopulateAttributeModel = function (attributeData) {
        console.log("populate attribute ", attributeData);

        that.AttributeId(attributeData.ObjectAttributeId);
        that.DisplayColumns(attributeData.DisplayColumns);
        that.LocalizationKey(attributeData.LocalizationKey);
        that.Description(attributeData.Description);
        that.DefaultObjectValueId(attributeData.DefaultObjectValueId);
        that.PopulateObjectValues(attributeData.ObjectValues);

        that.CustomValue.IsCustomValueOptionSelected(that.CustomValue.IsCustomValueOptionAvailable());
    };
    
    that.PopulateDefaultObjectValue = function() {
        var selectedValues = pageModelHndl.pProductModel.SelectedAttributeAndExtensionValues().filter( function(element) {
            return element.AttributeId === that.AttributeId() && element.IsExtension === that.IsExtension();
        });
        
        if(that.DefaultObjectValueId() && selectedValues.length === 0) {
            
            that.SelectedObjectValueId(that.DefaultObjectValueId());

            var productConfigurationFilterItem = new ProductConfigurationFilterItem(that);
            pageModelHndl.pProductModel.SelectedAttributeAndExtensionValues
                .push(productConfigurationFilterItem);

            if (that.IsExtension() && (that.AttributeId() === extentId || that.AttributeId() === extentV3Id)) {
                // Disables Extension configuration when no cover is selected
                parentHndl.IsDisabled(that.DefaultObjectValueId() === noCoverObjectValueId || that.DefaultObjectValueId() === noCoverObjectValueV3Id);
            }
        }
    }

    that.RePopulateAttributeModel = function (selectedValueIds) {
        var success = false;

        $.each(that.ObjectValues(), function (i, obj) {
            if ($.inArray(obj.ObjectValueId(), selectedValueIds) > -1) {
                that.SelectedObjectValueId(obj.ObjectValueId());
                that.InnerLastSelected(obj.ObjectValueId());
                that.IsCorrectionMode(false);
                success = true;
            }

            var isLastItem = i === (that.ObjectValues()).length - 1;
            if (isLastItem) {
                if (!success) {
                    that.SelectedObjectValueId(undefined);
                }
            }
        });
    };

    that.UpdateAttributeModel = function (selectableValueIds, IsExtension) {
        if (!selectableValueIds || selectableValueIds.length === 0) {
            //nothing to do here
            return;
        }

        $.each(that.ObjectValues(), function (i, obj) {
            var inSelectedValueList = $.inArray(obj.ObjectValueId(), selectableValueIds) > -1;

            obj.HasError(false);
            obj.IsEnabled(inSelectedValueList);

            var radioBox = $("input[value=" + obj.ObjectValueId() + ']');

            var checkedState = radioBox.is(':checked');

            if (that.SelectedObjectValueId() &&
                that.SelectedObjectValueId() === obj.ObjectValueId() &&
                $.inArray(obj.ObjectValueId(), selectableValueIds) === -1 && checkedState && !obj.IsEnabled()) {

                removeFromSelectedAttributeAndExtensionValues(obj.ParentAttribute().AttributeId(), obj.ParentAttribute().IsExtension());
                obj.HasError(true);
                radioBox.prop("checked", false);
                that.SelectedObjectValueId(undefined);
                pageModelHndl.pProductModel.LastSelectedObjectValue(-1);
            }
        });
    };

    that.PopulateObjectValues = function (objectValuesData) {
        that.ObjectValues([]);

        $.each(objectValuesData, function (i, obj) {
            var objectValueModel = new ObjectValueModel(pageModelHndl, that);
            objectValueModel.PopulateObjectValueModel(obj);

            that.ObjectValues.push(objectValueModel);
            that._BeginnerObjectValues.push(objectValueModel);

            var isLastItem = i === (objectValuesData.length - 1);
            if (isLastItem) {

                // pre select object value if there is only 1
                if (objectValuesData.length === 1) {
                    var id = objectValuesData[0].ObjectValueId;
                    that.SelectedObjectValueId(id);

                    var productConfigurationFilterItem = new ProductConfigurationFilterItem(that);
                    pageModelHndl.pProductModel.SelectedAttributeAndExtensionValues
                        .push(productConfigurationFilterItem);
                }
            }
        });
    };

    function getObjectValue(attribute, objectValueId) {
        var objectValues = attribute.ObjectValues();

        var filtered = objectValues.filter(function (item) {
            return item.ObjectValueId() === objectValueId;
        });

        var isEmpty = filtered.length === 0;
        if (isEmpty) {
            return null;
        }

        var selectedObjectValue = filtered[0];
        return selectedObjectValue;
    }

    function removeFromSelectedAttributeAndExtensionValues(attributeId, isExtension) {
        var elementsToRemove = pageModelHndl.pProductModel
            .SelectedAttributeAndExtensionValues().filter(function(el) {
                return el.AttributeId === attributeId && el.IsExtension === isExtension;
            });
        pageModelHndl.pProductModel.SelectedAttributeAndExtensionValues(pageModelHndl.pProductModel
            .SelectedAttributeAndExtensionValues().filter(function(el) {
                return elementsToRemove.indexOf(el) < 0;
            }));
    }
};
